/**
 * This component is mounted at the buy/success route of our client-side router
 * and renders either the normal buy-success component or the Outlook-specific
 * success component.
 */
import PropTypes from 'prop-types'

import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import OutlookSuccess from './outlook-success'
import BuySuccess from './buy-success'
import { withRouter } from 'react-router-dom'
import * as ViewActions from '../actions/Actions'
import DCSendMoneyRequestSuccess from './dcSendMoneyRequestSuccess'
import _ from 'lodash'

class BuySuccessWrapper extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isOutlookFlow: PropTypes.bool.isRequired,
    isDCSendMoneyRequest: PropTypes.bool.isRequired,
    unified: PropTypes.bool,
  }

  componentWillUnmount() {
    this.props.dispatch(ViewActions.leavingSuccessPage())
  }

  render() {
    if (this.props.isOutlookFlow) {
      return <OutlookSuccess />
    }
    if (this.props.isDCSendMoneyRequest) {
      return <DCSendMoneyRequestSuccess />
    }
    return <BuySuccess unified={!!this.props.unified} />
  }
}

export default withRouter(
  connect(({ server }) => ({
    isOutlookFlow: server.env === 'outlook',
    isDCSendMoneyRequest: _.get(
      server,
      'businessAccountInfo.isDCSendMoneyRequest',
      false
    ),
  }))(BuySuccessWrapper)
)
